export const REQUEST_ADDITIONAL_ACTION = "REQUEST_ADDITIONAL_ACTION";
export const REQUEST_ADDITIONAL_ACTION_SUCCEEDED = "REQUEST_ADDITIONAL_ACTION_SUCCEEDED";
export const REQUEST_ADDITIONAL__ACTION_FAILED = "REQUEST_ADDITIONAL_ACTION_FAILED";
export const SAVE_ADDITIONAL_ACTION_INFO = "SAVE_ADDITIONAL_ACTION_INFO";
export const SAVE_ADDITIONAL_ACTION_INFO_SUCCEEDED = "SAVE_ADDITIONAL_ACTION_INFO_SUCCEEDED";
export const SAVE_ADDITIONAL_ACTION_INFO_FAILED = "SAVE_ADDITIONAL_ACTION_INFO_FAILED";

export const requestAdditionalAction = () => {
    return {
        type: REQUEST_ADDITIONAL_ACTION,
    };
};

export const requestAdditionalActionSucceeded = (additionalActionStatus) => {
    return {
        type: REQUEST_ADDITIONAL_ACTION_SUCCEEDED,
        additionalActionStatus,
    };
};

export const requestAdditionalActionFailed = (message) => {
    return {
        type: REQUEST_ADDITIONAL__ACTION_FAILED,
        message,
    };
};

export const saveAdditionalAction = (additionalActionRequest, workOrderNumber, username, refresh) => {
    return {
        type: SAVE_ADDITIONAL_ACTION_INFO,
        additionalActionRequest,
        workOrderNumber,
        username,
        refresh,
    };
};

export const saveAdditionalActionSucceeded = (additionalActionResponse) => {
    return {
        type: SAVE_ADDITIONAL_ACTION_INFO_SUCCEEDED,
        additionalActionResponse,
    };
};

export const saveAdditionalActionFailed = (message) => {
    return {
        type: SAVE_ADDITIONAL_ACTION_INFO_FAILED,
        message,
    };
};
